import { userRoles } from 'lib-shared-legacy-types';
import { agentHasRole } from './agentHasRole';
export const agentRoles = userRoles.filter((role) => role !== 'enduser');
const atLeastPrefix = 'at_least_';
/**
 * Checks an agent against all possible agent roles and returns which roles the
 * agent does and does not belong to.
 *
 * @param agent The agent to check the roles against.
 */
export function currentAgentRoles(agent) {
    return agentRoles.reduce((roles, role) => (Object.assign(Object.assign({}, roles), { [`${atLeastPrefix}${role}`]: agentHasRole(agent, role) })), {});
}
